import React from 'react';
import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import { H4, P, Toggle } from '@decisiv/ui-components';

import useBetaFeatures from '../../hooks/useBetaFeatures';
import {
  ProfileSection,
  SectionHeader,
  SectionTitle,
  FeatureRow,
  FeatureText,
} from './style';

export default function FeaturesTab() {
  const { features, isEnabled, setEnabled } = useBetaFeatures();

  return (
    <ProfileSection>
      <SectionHeader>
        <SectionTitle>{t`Beta features`}</SectionTitle>
      </SectionHeader>
      <P color="alaskanHusky" paddingX={2} paddingTop={1}>
        <Trans>
          Try features before they ship. Settings apply to this browser only.
        </Trans>
      </P>
      {features.map(({ id, name, description }) => (
        <FeatureRow key={id}>
          <FeatureText>
            <H4 id={`feature_${id}_name`}>{i18n._(name)}</H4>
            <P color="alaskanHusky" size="small">
              {i18n._(description)}
            </P>
          </FeatureText>
          <Toggle
            name={`feature_${id}`}
            aria-labelledby={`feature_${id}_name`}
            size="small"
            options={[
              { id: 'off', text: t`Off` },
              { id: 'on', text: t`On` },
            ]}
            selected={isEnabled(id) ? 'on' : 'off'}
            onChange={(optionId) => setEnabled(id, optionId === 'on')}
          />
        </FeatureRow>
      ))}
    </ProfileSection>
  );
}
